/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyUploadedDataPackageSlug } from './CompanyUploadedDataPackageSlug';
import {
    CompanyUploadedDataPackageSlugFromJSON,
    CompanyUploadedDataPackageSlugFromJSONTyped,
    CompanyUploadedDataPackageSlugToJSON,
    CompanyUploadedDataPackageSlugToJSONTyped,
} from './CompanyUploadedDataPackageSlug';

/**
 * Serializer for creating new data uploads and listing them.
 * @export
 * @interface CompanyUploadedDataPackage
 */
export interface CompanyUploadedDataPackage {
    /**
     * 
     * @type {string}
     * @memberof CompanyUploadedDataPackage
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUploadedDataPackage
     */
    description: string;
    /**
     * 
     * @type {CompanyUploadedDataPackageSlug}
     * @memberof CompanyUploadedDataPackage
     */
    slug?: CompanyUploadedDataPackageSlug;
    /**
     * 
     * @type {string}
     * @memberof CompanyUploadedDataPackage
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUploadedDataPackage
     */
    readonly uploadedByName: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyUploadedDataPackage
     */
    readonly uploadedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyUploadedDataPackage
     */
    readonly uploadComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyUploadedDataPackage
     */
    readonly archiving: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyUploadedDataPackage
     */
    readonly archiveAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyUploadedDataPackage
     */
    readonly virusDetected: boolean;
}

/**
 * Check if a given object implements the CompanyUploadedDataPackage interface.
 */
export function instanceOfCompanyUploadedDataPackage(value: object): value is CompanyUploadedDataPackage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if ((!('uploadedByName' in (value as Record<string, any>)) && !('uploaded_by_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadedByName'] === undefined && (value as Record<string, any>)['uploaded_by_name'] === undefined)) return false;
    if ((!('uploadedAt' in (value as Record<string, any>)) && !('uploaded_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadedAt'] === undefined && (value as Record<string, any>)['uploaded_at'] === undefined)) return false;
    if ((!('uploadComplete' in (value as Record<string, any>)) && !('upload_complete' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadComplete'] === undefined && (value as Record<string, any>)['upload_complete'] === undefined)) return false;
    if (!('archiving' in value) || value['archiving'] === undefined) return false;
    if ((!('archiveAvailable' in (value as Record<string, any>)) && !('archive_available' in (value as Record<string, any>))) || ((value as Record<string, any>)['archiveAvailable'] === undefined && (value as Record<string, any>)['archive_available'] === undefined)) return false;
    if ((!('virusDetected' in (value as Record<string, any>)) && !('virus_detected' in (value as Record<string, any>))) || ((value as Record<string, any>)['virusDetected'] === undefined && (value as Record<string, any>)['virus_detected'] === undefined)) return false;
    return true;
}

export function CompanyUploadedDataPackageFromJSON(json: any): CompanyUploadedDataPackage {
    return CompanyUploadedDataPackageFromJSONTyped(json, false);
}

export function CompanyUploadedDataPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUploadedDataPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'],
        'slug': json['slug'] == null ? undefined : CompanyUploadedDataPackageSlugFromJSON(json['slug']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'uploadedByName': json['uploaded_by_name'],
        'uploadedAt': (new Date(json['uploaded_at'])),
        'uploadComplete': json['upload_complete'],
        'archiving': json['archiving'],
        'archiveAvailable': json['archive_available'],
        'virusDetected': json['virus_detected'],
    };
}

export function CompanyUploadedDataPackageToJSON(json: any): CompanyUploadedDataPackage {
    return CompanyUploadedDataPackageToJSONTyped(json, false);
}

export function CompanyUploadedDataPackageToJSONTyped(value?: Omit<CompanyUploadedDataPackage, 'id'|'uploadedByName'|'uploadedAt'|'uploadComplete'|'archiving'|'archiveAvailable'|'virusDetected'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'slug': CompanyUploadedDataPackageSlugToJSON(value['slug']),
        'notes': value['notes'],
    };
}

